import React from 'react';
import Metrics from '../Metrics';
import Summary from '../Summary';
import DiscountTable from '../Tables/DiscountTable';

const Overview = () => (
  <div className="flex flex-col gap-y-4">
    <Metrics />
    <Summary />
    <DiscountTable />
  </div>
);

export default Overview;
